import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  locationWrap: FelaCSS;
  heading: FelaCSS;
}

const styles = (isVenueProfileV2?: boolean): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingBottom: spacing[4],

    ...(isVenueProfileV2 && {
      justifyContent: 'initial',
      gap: spacing[2],
      paddingBottom: spacing[0],
    }),

    maxWidthTabletSm: {
      paddingBottom: '0',
      borderBottom: 'none',
    },
  },

  locationWrap: {
    flexShrink: 0,
    marginBottom: '9px',
    width: '100%',

    maxWidthTabletSm: {
      marginBottom: '0',
      width: 'calc(100% - 140px)',
    },

    ...(isVenueProfileV2 && {
      order: -1,
      width: 'initial',
      margin: `${spacing[0]} ${spacing[2]} ${spacing[0]} ${spacing[0]}`,
      maxWidthTabletSm: {
        width: '100%',
        marginBottom: spacing[1],
      },
    }),
  },

  heading: {
    maxWidth: '100%',
    flexShrink: 0,
    marginTop: 0,
    marginBottom: 0,
    fontDefaultSemiBold: 30,
    lineHeight: '1.25em',
    letterSpacing: '-0.0062em',
    color: colors.space,

    maxWidthTabletSm: {
      order: 3,
      marginTop: '17px',
      width: '100%',
      fontDefaultSemiBold: 24,
      letterSpacing: '-0.005em',
    },

    ...(isVenueProfileV2 && {
      order: -2,
      width: '100%',
      marginTop: spacing[8],
      fontPlayfair: 26,
      fontWeight: 800,
      lineHeight: spacing[8],

      maxWidthTabletSm: {
        marginTop: 0,
      },
    }),
  },
});

export default styles;
